module.exports = __webpack_public_path__ + "static/media/man-using-atm-machine.49544c6e.png";